import blocksConfig from '@assets/config/blocks.json';

const imageModules = import.meta.glob('/assets/images/blocks/season1/*.png', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

const svgModules = import.meta.glob('/assets/images/blocks/season1/*.svg', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

const createPathMap = (
  modules: Record<string, string>,
): Record<string, string> => {
  const map: Record<string, string> = {};
  for (const [key, value] of Object.entries(modules)) {
    const relativePath = key.replace(/^\/?assets\//, '');
    map[relativePath] = value;
  }
  return map;
};

export const imagePathMap = createPathMap(imageModules);
export const svgPathMap = createPathMap(svgModules);

export const blockImageMap: Record<number, string> = blocksConfig.reduce<
  Record<number, string>
>((acc, config) => {
  const resolved = imagePathMap[config.imagePath];
  if (resolved) {
    acc[config.id] = resolved;
  }
  return acc;
}, {});
